module.exports = __webpack_public_path__ + "img/shipo-icon-vessel.acd64e38.svg";